/* eslint-disable class-methods-use-this */
/* eslint-disable react/button-has-type */
import React from 'react'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import withFirebaseAuth from 'react-with-firebase-auth'
import { ScaleLoader } from 'react-spinners'

import LoadingOverlay from 'react-loading-overlay'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import CallToBuy from './shared/components/callToBuy/CallToBuy'
import { Login } from './shared/components/login'
import Button from './shared/components/Button'
import AccountUtil from './shared/util/AccountUtil'

import './shared/global-style.css'
import S from './shared/App.module.css'
import LS from './shared/components/login/Login.module.css'
import A from './App.module.css'

import FunctionsApi from './shared/util/FunctionsApi'
import WaitingToVerify from './shared/components/verify/WaitingToVerify'

import CheckoutDone from './checkout/CheckoutDone'
import NotFound from './checkout/NotFound'
import icon from './shared/img/icon-128.png'
import ConfigureGDrive from './configureGDrive/ConfigureGDrive'

// eslint-disable-next-line no-undef
const firebaseConfig = JSON.parse( process.env.REACT_APP_FIREBASE_CONFIG )
const firebaseApp = firebase.initializeApp( firebaseConfig )
const firebaseAppAuth = firebaseApp.auth()
/** See the signature above to find out the available providers */
const providers = {
  googleProvider : new firebase.auth.GoogleAuthProvider(),
}

/** Create the FirebaseAuth component wrapper */
const createComponentWithAuth = withFirebaseAuth( {
  providers,
  firebaseAppAuth,
} )

class App extends React.Component {

  constructor( props ) {
    super( props )
    this.state = {
      loading : true,
      loadingText : '',
      createdNewUser : false,
      sceneState : 'login', // 'login',  'prebuy', 'unverified', 'buy', 'preuserinfo', 'userinfo'
      errorCode : null,
      fbUser : null,
    }
  }

  async componentDidMount() {
    this.setState( { loading : false } )
  }

  componentDidUpdate( prevProps ) {
    const { user } = this.props
    const { sceneState } = this.state
    if ( !prevProps.user && user ) {
      if ( sceneState === 'newuser' ) {
        return;
      }
      console.log( `${user.email} signed in` );
      this.updateLoading( true, 'Loading user information...' );
      firebase.database().ref( `users/${user.uid}` ).on( 'value', this.handleUserLoad )
      this.setState( { email : user.email } ); // eslint-disable-line react/no-did-update-set-state
      if ( sceneState.startsWith( 'pre' ) ) {
        this.setState( { sceneState : sceneState.substring( 3 ) } ); // eslint-disable-line react/no-did-update-set-state
      }
    } else if ( prevProps.user && !user ) {
      console.log( `${prevProps.user.email} signed out` );
      this.setState( { createdNewUser : false } ); // eslint-disable-line react/no-did-update-set-state
    }
  }

  handleUserLoad = ( snap ) => {
    const s = snap.val();
    console.debug( 'handleUserLoad: ', s );
    this.setState( {
      fbUser : s,
    }, this.checkVerified )
  }

  setErrorCode = ( errorCode ) => {
    this.setState( { errorCode } );
  }

  getErrorCode = () => {
    const { errorCode } = this.state
    return errorCode
  }

  getCanceledRow( canceledAt ) {
    if ( canceledAt ) {
      return (
        <tr>
          <th>Subscription Canceled on</th>
          <td>{new Date( canceledAt * 1000 ).toLocaleDateString( navigator.language )}</td>
        </tr>
      )
    }
    return null;
  }

  loadSubscriptionInfo = async () => {
    const { user } = this.props;
    const { fbUser } = this.state;
    try {
      if ( fbUser.stripeSubscription ) {
        console.log( 'subscription status:', fbUser.stripeSubscription.status )
      } else {
        console.log( 'subscription status: none' )
      }
      if ( fbUser.version !== 2 ) {
        await FunctionsApi.refreshSubscriptionInfo()
        console.debug( 'updated database entry to version 2' )
      }
    } catch ( error ) {
      console.error( `error refreshing subscription info: ${error}` );
      this.setErrorCode( 'func/unavailable' );
    } finally {
      this.updateLoading( false );
      this.userSignedIn( user?.email );
      this.doUserSignedIn();
    }
  }

  updateLoading = ( loading, text ) => {
    const { loadingText, sceneState } = this.state;
    if ( loading ) {
      console.log( `Loading "${text}` );
    } else {
      console.log( `Done loading "${loadingText}: ${sceneState}"` );
    }
    this.setState( { loading, loadingText : text } );
  }

  sceneFromSubscriptionInfo = () => {
    const { fbUser } = this.state;
    if ( fbUser?.stripeSubscription?.status === 'active' ) {
      return 'userinfo';
    }
    return 'buy';

  }

  creatingNewUser = () => {
    this.setState( { sceneState : 'newuser' } )
  }

  userCreated = ( email ) => {
    this.setState( { email, sceneState : 'login', createdNewUser : true } )
  }

  doUserSignedIn = () => {
    const { user } = this.props;
    if ( !user ) {
      console.error( 'Illegal state. no user defined for doUserSignedIn' );
      return;
    }
    if ( this.getErrorCode() !== 'func/unavailable' ) {
      const sceneState = this.sceneFromSubscriptionInfo();
      this.setState( { sceneState } );
    } else {
      AccountUtil.signOut();
      this.setState( { sceneState : 'login' } );
    }
  }

  userSignedIn = ( email ) => {
    const sceneState = this.sceneFromSubscriptionInfo();
    this.setState( { email, sceneState : `pre${sceneState}` } )
  }

  userSignedOut = () => {
    this.setState( { sceneState : 'login' } );
  }

  getSceneLogin = () => {
    const { email, createdNewUser } = this.state
    return (
      <div className={LS.loginContainer}>
        <div className={LS.titleContainer}>
          <img height="40px" src={icon} alt="Script Keeper" />
          <div className={LS.title} style={{ overflow : 'visible', whiteSpace : 'nowrap' }}>Script Keeper User Portal</div>
        </div>
        <form>
          <Login
            {...this.props} // eslint-disable-line react/jsx-props-no-spreading
            googleProvider={providers.googleProvider}
            auth={firebaseAppAuth}
            setLoading={this.updateLoading}
            email={email}
            createdNewUser={createdNewUser}
            errorContext={{ setErrorCode : this.setErrorCode, getErrorCode : this.getErrorCode }}
          />
        </form>
      </div>
    );
  }

  getSceneBuy = () => {
    const { user } = this.props;
    return ( <CallToBuy user={user} setLoading={this.updateLoading} userSignedOut={this.userSignedOut} /> )
  }

  checkVerified = async () => {
    const { user } = this.props
    if ( user.emailVerified ) {
      await this.loadSubscriptionInfo()
    } else {
      this.setState( { sceneState : 'unverified', loading : false } )
    }
  }

  getCaptionMessage = ( isCanceled ) => {
    if ( isCanceled ) {
      return (
        <span>
          The subscription will no longer be active after the end of the current period.
          <br />
          To renew, use the&nbsp;
          <em>Manage Account</em>
          {' '}
          button below, then click
          <em>Renew Plan</em>
          .
        </span>
      )
    }
    return ( <span>&nbsp;</span> );

  }

  goToCustomerDashboard = async () => {

    this.updateLoading( true );
    try {
      await FunctionsApi.goToCustomerDashboardAsync();
    } catch ( error ) {
      console.error( 'Could not load customer dashboard:', error );
      this.setErrorCode( 'dashboard/unavailable' );
    }
    this.updateLoading( false );
  }

  getSceneUnverified = () => (
    <div className={LS.loginContainer}>
      <div className={LS.titleContainer}>
        <img height="40px" src={icon} alt="Script Keeper" />
        <div className={LS.title}>Script Keeper</div>
      </div>
      <WaitingToVerify signedOut={this.userSignedOut} />
    </div>
  )

  getSceneUserInfo = () => {
    const { user } = this.props;
    const { fbUser } = this.state;
    const { stripeSubscription } = fbUser;
    const isCanceled = stripeSubscription.canceled_at !== null
    return (
      <div className={A.centerContainer}>
        <div className={LS.titleContainer}>
          <img height="40px" src={icon} alt="Script Keeper" />
          <h1 className={LS.title} style={{ overflow : 'visible', whiteSpace : 'nowrap' }}>Account Details</h1>
        </div>
        <div>
          <table className={A.table}>
            <tbody>
              <tr>
                <th>Account Email</th>
                <td>{user.email}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{user.displayName}</td>
              </tr>
              <tr>
                <th>Customer ID</th>
                <td><code>{fbUser.stripeCustomerId}</code></td>
              </tr>
              <tr>
                <th>Subscribed Since</th>
                <td>{new Date( stripeSubscription.created * 1000 ).toLocaleDateString( navigator.language )}</td>
              </tr>
              {this.getCanceledRow( stripeSubscription.canceled_at )}
              <tr>
                {isCanceled ? <th>Subscription Ends</th> : <th>Next Renewal</th>}
                <td>{new Date( stripeSubscription.current_period_end * 1000 ).toLocaleDateString( navigator.language )}</td>
              </tr>
            </tbody>
            <caption>{this.getCaptionMessage( isCanceled )}</caption>
          </table>
        </div>
        <div className={A.buttons}>
          <Button scheme="primary" onClick={this.goToCustomerDashboard}>Manage Account</Button>
          <Button scheme="primaryInverted" onClick={() => { AccountUtil.signOut(); this.userSignedOut(); }}>Sign Out</Button>
        </div>
        <p className={LS.error} style={{ textAlign : 'center' }}>
          {this.getErrorCode() === 'dashboard/unavailable' ? <span>Account dashboard is currently unavailable</span> : null}
        </p>
      </div>
    );
  }

  renderCurrentScene = () => {
    const { sceneState } = this.state;
    switch ( sceneState ) {
      case 'login':
        return this.getSceneLogin();
      case 'buy':
        return this.getSceneBuy();
      case 'userinfo':
        return this.getSceneUserInfo();
      case 'unverified':
        return this.getSceneUnverified();
      case 'prebuy':
      case 'preuserinfo':
      case 'newuser':
        break;
      default:
        console.error( 'illegal sceneState value:', sceneState );
    }
    return null;
  }

  getInnerContainerClass = () => {
    const { sceneState } = this.state;
    return sceneState === 'userinfo' ? S.container : LS.container
  }

  render() {
    const { loading, loadingText } = this.state

    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <LoadingOverlay
              active={loading}
              text={( <div style={{ margin : 15, color : '#bcbcbc', fontWeight : 'bold', fontSize : '20pt' }}>{loadingText}</div> )}
              spinner={<ScaleLoader margin={7} height={60} width={7} color="#84A6C2" />}
            >
              <div className={A.container}>
                <div className={this.getInnerContainerClass()}>
                  {this.renderCurrentScene()}
                </div>
              </div>
            </LoadingOverlay>
          </Route>
          <Route path="/checkout/success">
            <div className={A.container}>
              <div className={A.centerContainer}>
                <CheckoutDone status="success" />
              </div>
            </div>
          </Route>
          <Route path="/checkout/canceled">
            <div className={A.container}>
              <div className={A.centerContainer}>
                <CheckoutDone status="canceled" />
              </div>
            </div>
          </Route>
          <Route path="/configureGDrive">
            <ConfigureGDrive onSelection={console.log} />
          </Route>
          <Route component={NotFound} />
        </Switch>
      </Router>
    )
  }
}

export default createComponentWithAuth( App )
